import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {SoundManager} from "./sound/SoundManager";
import {SoundConfig} from "./sound/SoundConfig";
import {PRGameMode} from "./server/PRGameMode";
import {BaseModel} from "./server/base/BaseModel";

export class PunkRocker2PromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "PunkRocker2",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "bonusGameReelAssets/mainBackground2"},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                // parsedData.isBigWin = this.isBigWin(response.totalSpinWinnings, response.playedBetValue, response.mode);
                return parsedData;
            }
        };
    }

    isLegalStopOnBonusMode(data: IResponseData): boolean {
        return data.nextMode != PRGameMode.RESPIN;
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSoundEffect(SoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(SoundConfig.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        let win: number = response.totalSpinWinnings,
            winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice: number = BaseModel.getBetPriceForActionSpins();
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: any): string {
        if (response.mode == PRGameMode.FREESPIN_LEVEL_ONE || response.nextMode == PRGameMode.FREESPIN_LEVEL_ONE) {
            return "DisOBEY! SPINS";
        } else if (response.mode == PRGameMode.FREESPIN_LEVEL_TWO || response.nextMode == PRGameMode.FREESPIN_LEVEL_TWO) {
            return "ChAos SPINS";
        } else if (response.mode == PRGameMode.FREESPIN_LEVEL_THREE || response.nextMode == PRGameMode.FREESPIN_LEVEL_THREE) {
            return "Mass Transit Barbeque SPINS";
        } else if (response.mode == PRGameMode.RESPIN || response.nextMode == PRGameMode.RESPIN) {
            return "Riot Spins";
        }
        return response.mode;
    }

    private isFreeSpinTriggered(response: any): boolean {
        return response.mode === PRGameMode.NORMAL && response.nextMode !== PRGameMode.NORMAL;
    }

    private isRoundComplete(response: any): boolean {
        return ([PRGameMode.NORMAL, PRGameMode.RESPIN, PRGameMode.FREESPIN_LEVEL_ONE, PRGameMode.FREESPIN_LEVEL_TWO, PRGameMode.FREESPIN_LEVEL_THREE].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return response.mode !== PRGameMode.NORMAL && response.nextMode === PRGameMode.NORMAL;
    }
}